// Shared data used across the app
export const NAV_LINKS = [
    { key: "borgo",     label: { it: "Il Borgo",          en: "The Village",   fr: "Le Village",       es: "El Pueblo",         de: "Das Dorf" },        href: "#il-borgo",  route: "/",                  testid: "nav-borgo" },
    { key: "gemello",   label: { it: "Gemello Digitale",  en: "Digital Twin",  fr: "Jumeau Numérique", es: "Gemelo Digital",    de: "Digitaler Zwilling" }, href: "#gemello",   route: "/gemello-digitale",  testid: "nav-gemello" },
    { key: "attrazioni",label: { it: "Attrazioni",        en: "Attractions",   fr: "Attractions",      es: "Atracciones",       de: "Sehenswürdigkeiten"},   href: "#attrazioni",route: "/attrazioni",        testid: "nav-attrazioni" },
    { key: "immobili",  label: { it: "Immobili",          en: "Properties",    fr: "Immobilier",       es: "Inmuebles",         de: "Immobilien" },      href: "",           route: "/immobili",          testid: "nav-immobili" },
    { key: "itinerari", label: { it: "Itinerari",         en: "Itineraries",   fr: "Itinéraires",      es: "Itinerarios",       de: "Routen" },          href: "",           route: "/itinerari",         testid: "nav-itinerari" },
    { key: "eventi",    label: { it: "Eventi",            en: "Events",        fr: "Événements",       es: "Eventos",           de: "Veranstaltungen" }, href: "#eventi",    route: "/eventi",            testid: "nav-eventi" },
    { key: "contatti",  label: { it: "Contatti",          en: "Contact",       fr: "Contact",          es: "Contacto",          de: "Kontakt" },         href: "#contatti",  route: "/",                  testid: "nav-contatti" },
];

export const BORGO_IMAGES = [
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/Tadasuni-Casa-Pinna-retro.jpg",
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/lagop-omodeo.jpg",
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/vista-paese_2_DJI_0228_modificata.jpg",
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/chiesetta-san-michele.jpg",
];

export const HERO_IMAGE =
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/vista-paese_lago_DJI_0228.jpg";

export const DIGITAL_TWIN_IMAGE =
    "https://www.visittadasuni.it/wp-content/uploads/2025/11/vista-paese_2_DJI_0228_modificata.jpg";

export const ATTRAZIONI_CARDS = [
    {
        icon: "church",
        title: { it: "Chiese Storiche", en: "Historic Churches", fr: "Églises Historiques", es: "Iglesias Históricas", de: "Historische Kirchen" },
        desc:  { it: "Santa Croce, San Nicola di Bari, San Michele", en: "Santa Croce, San Nicola di Bari, San Michele", fr: "Santa Croce, San Nicola di Bari, San Michele", es: "Santa Croce, San Nicola di Bari, San Michele", de: "Santa Croce, San Nicola di Bari, San Michele" },
        image: "https://www.visittadasuni.it/wp-content/uploads/2025/11/Tadasuni-Chiesa-Santa-Croce.jpg",
    },
    {
        icon: "palette",
        title: { it: "Ceramiche Artistiche", en: "Artistic Ceramics", fr: "Céramiques Artistiques", es: "Cerámicas Artísticas", de: "Kunstkeramik" },
        desc:  { it: "Itinerario delle ceramiche tradizionali sarde", en: "Traditional Sardinian ceramics itinerary", fr: "Itinéraire des céramiques traditionnelles sardes", es: "Itinerario de la cerámica tradicional sarda", de: "Route der traditionellen sardischen Keramik" },
        image: "https://www.visittadasuni.it/wp-content/uploads/2025/11/pietra-logo-tadasuni.jpg",
    },
    {
        icon: "trees",
        title: { it: "Natura e Paesaggi", en: "Nature & Landscapes", fr: "Nature & Paysages", es: "Naturaleza y Paisajes", de: "Natur & Landschaften" },
        desc:  { it: "Lago Omodeo, giardini e macchia mediterranea", en: "Lake Omodeo, gardens and Mediterranean scrub", fr: "Lac Omodeo, jardins et maquis méditerranéen", es: "Lago Omodeo, jardines y maquia mediterránea", de: "Omodeo-See, Gärten und mediterrane Macchia" },
        image: "https://www.visittadasuni.it/wp-content/uploads/2025/11/Tadasuni-Parco-pubblico-1.jpg",
    },
];

export const T = {
    it: {
        hero_title: "Tadasuni Borgo Experience",
        hero_sub: "Tra lago, colline e tradizioni: la tua nuova vita comincia a Tadasuni",
        cta_scopri: "Scopri di più",
        cta_gemello: "Gemello Digitale",
        borgo_title: "Un piccolo gioiello della Sardegna",
        borgo_desc: "Tadasuni è un piccolissimo borgo della Sardegna centrale, situato nella regione storica del Barigadu. Sorge su un rilievo collinare a circa 180 metri di altitudine, affacciato sul magnifico Lago Omodeo.",
        stat_alt: "Altitudine",
        stat_pop: "Abitanti",
        gemello_title: "Gemello Digitale",
        gemello_sub: "Esplora Tadasuni in 3D con il nostro tour virtuale interattivo",
        gemello_cta: "Esplora Ora",
        attrazioni_title: "Attrazioni",
        eventi_title: "Eventi e Notizie",
        eventi_read_more: "Leggi di più",
        contact_title: "Contattaci",
        contact_name: "Nome",
        contact_email: "Email",
        contact_phone: "Telefono",
        contact_message: "Messaggio",
        contact_consent: "Accetto il trattamento dei dati personali",
        contact_send: "Invia",
        contact_success: "Messaggio inviato! Grazie di averci scritto.",
        contact_error: "Si è verificato un errore. Riprova.",
        chat_title: "Assistente Tadasuni",
        chat_placeholder: "Fai una domanda sul borgo…",
        chat_welcome: "Ciao! Sono l'assistente di Tadasuni. Cosa vorresti scoprire del borgo?",
        chat_send: "Invia",
        eventi_page_title: "Eventi e Notizie",
        eventi_page_sub: "Scopri gli eventi e le notizie dal borgo di Tadasuni",
        back_home: "Torna alla Home",
        attr_page_title: "Scopri Tadasuni",
        attr_page_sub: "Attrazioni, ristoranti, alloggi e itinerari",
        tab_all: "Tutti",
        tab_attractions: "Attrazioni",
        tab_food: "Dove Mangiare",
        tab_stay: "Dove Dormire",
        tab_itin: "Itinerari",
        map_link: "Vedi su mappa",
        footer_tag: "Borgo Experience — Sardegna centrale, Barigadu",
    },
    en: {
        hero_title: "Tadasuni Village Experience",
        hero_sub: "Between lake, hills and traditions: your new life begins in Tadasuni",
        cta_scopri: "Discover more",
        cta_gemello: "Digital Twin",
        borgo_title: "A small jewel of Sardinia",
        borgo_desc: "Tadasuni is a tiny village in central Sardinia, located in the historic Barigadu region. It sits on a hilltop at about 180 metres, overlooking the magnificent Lake Omodeo.",
        stat_alt: "Altitude",
        stat_pop: "Inhabitants",
        gemello_title: "Digital Twin",
        gemello_sub: "Explore Tadasuni in 3D with our interactive virtual tour",
        gemello_cta: "Explore Now",
        attrazioni_title: "Attractions",
        eventi_title: "Events & News",
        eventi_read_more: "Read more",
        contact_title: "Contact us",
        contact_name: "Name",
        contact_email: "Email",
        contact_phone: "Phone",
        contact_message: "Message",
        contact_consent: "I accept the processing of personal data",
        contact_send: "Send",
        contact_success: "Message sent! Thank you for reaching out.",
        contact_error: "Something went wrong. Please try again.",
        chat_title: "Tadasuni Assistant",
        chat_placeholder: "Ask a question about the village…",
        chat_welcome: "Hi! I'm the Tadasuni assistant. What would you like to discover about the village?",
        chat_send: "Send",
        eventi_page_title: "Events & News",
        eventi_page_sub: "Discover events and news from the village of Tadasuni",
        back_home: "Back to Home",
        attr_page_title: "Discover Tadasuni",
        attr_page_sub: "Attractions, restaurants, lodging and itineraries",
        tab_all: "All",
        tab_attractions: "Attractions",
        tab_food: "Where to Eat",
        tab_stay: "Where to Stay",
        tab_itin: "Itineraries",
        map_link: "View on map",
        footer_tag: "Village Experience — Central Sardinia, Barigadu",
    },
    fr: {
        hero_title: "Tadasuni Village Experience",
        hero_sub: "Entre lac, collines et traditions : votre nouvelle vie commence à Tadasuni",
        cta_scopri: "En savoir plus",
        cta_gemello: "Jumeau Numérique",
        borgo_title: "Un petit joyau de la Sardaigne",
        borgo_desc: "Tadasuni est un tout petit village de la Sardaigne centrale, situé dans la région historique du Barigadu. Il se dresse sur une colline à environ 180 mètres d'altitude, surplombant le magnifique lac Omodeo.",
        stat_alt: "Altitude",
        stat_pop: "Habitants",
        gemello_title: "Jumeau Numérique",
        gemello_sub: "Explorez Tadasuni en 3D grâce à notre visite virtuelle interactive",
        gemello_cta: "Explorer",
        attrazioni_title: "Attractions",
        eventi_title: "Événements & Actualités",
        eventi_read_more: "Lire la suite",
        contact_title: "Contactez-nous",
        contact_name: "Nom",
        contact_email: "Email",
        contact_phone: "Téléphone",
        contact_message: "Message",
        contact_consent: "J'accepte le traitement de mes données personnelles",
        contact_send: "Envoyer",
        contact_success: "Message envoyé ! Merci de nous avoir contactés.",
        contact_error: "Une erreur s'est produite. Veuillez réessayer.",
        chat_title: "Assistant Tadasuni",
        chat_placeholder: "Posez une question sur le village…",
        chat_welcome: "Bonjour ! Je suis l'assistant de Tadasuni. Que souhaitez-vous découvrir sur le village ?",
        chat_send: "Envoyer",
        eventi_page_title: "Événements & Actualités",
        eventi_page_sub: "Découvrez les événements et les actualités du village de Tadasuni",
        back_home: "Retour à l'accueil",
        attr_page_title: "Découvrir Tadasuni",
        attr_page_sub: "Attractions, restaurants, hébergements et itinéraires",
        tab_all: "Tout",
        tab_attractions: "Attractions",
        tab_food: "Où Manger",
        tab_stay: "Où Dormir",
        tab_itin: "Itinéraires",
        map_link: "Voir sur la carte",
        footer_tag: "Village Experience — Sardaigne centrale, Barigadu",
    },
    es: {
        hero_title: "Tadasuni Borgo Experience",
        hero_sub: "Entre lago, colinas y tradiciones: tu nueva vida comienza en Tadasuni",
        cta_scopri: "Descubre más",
        cta_gemello: "Gemelo Digital",
        borgo_title: "Una pequeña joya de Cerdeña",
        borgo_desc: "Tadasuni es un pequeñísimo pueblo de la Cerdeña central, situado en la región histórica del Barigadu. Se alza sobre una colina a unos 180 metros de altitud, asomado al magnífico lago Omodeo.",
        stat_alt: "Altitud",
        stat_pop: "Habitantes",
        gemello_title: "Gemelo Digital",
        gemello_sub: "Explora Tadasuni en 3D con nuestro recorrido virtual interactivo",
        gemello_cta: "Explorar Ahora",
        attrazioni_title: "Atracciones",
        eventi_title: "Eventos y Noticias",
        eventi_read_more: "Leer más",
        contact_title: "Contáctanos",
        contact_name: "Nombre",
        contact_email: "Email",
        contact_phone: "Teléfono",
        contact_message: "Mensaje",
        contact_consent: "Acepto el tratamiento de mis datos personales",
        contact_send: "Enviar",
        contact_success: "¡Mensaje enviado! Gracias por escribirnos.",
        contact_error: "Se ha producido un error. Inténtalo de nuevo.",
        chat_title: "Asistente Tadasuni",
        chat_placeholder: "Haz una pregunta sobre el pueblo…",
        chat_welcome: "¡Hola! Soy el asistente de Tadasuni. ¿Qué te gustaría descubrir sobre el pueblo?",
        chat_send: "Enviar",
        eventi_page_title: "Eventos y Noticias",
        eventi_page_sub: "Descubre los eventos y las noticias del pueblo de Tadasuni",
        back_home: "Volver al Inicio",
        attr_page_title: "Descubre Tadasuni",
        attr_page_sub: "Atracciones, restaurantes, alojamientos e itinerarios",
        tab_all: "Todos",
        tab_attractions: "Atracciones",
        tab_food: "Dónde Comer",
        tab_stay: "Dónde Dormir",
        tab_itin: "Itinerarios",
        map_link: "Ver en el mapa",
        footer_tag: "Borgo Experience — Cerdeña central, Barigadu",
    },
    de: {
        hero_title: "Tadasuni Dorf-Erlebnis",
        hero_sub: "Zwischen See, Hügeln und Traditionen: Ihr neues Leben beginnt in Tadasuni",
        cta_scopri: "Mehr entdecken",
        cta_gemello: "Digitaler Zwilling",
        borgo_title: "Ein kleines Juwel Sardiniens",
        borgo_desc: "Tadasuni ist ein winziges Dorf im Herzen Sardiniens, gelegen in der historischen Region Barigadu. Es liegt auf einem Hügel auf etwa 180 Metern Höhe und bietet einen Blick auf den prächtigen Omodeo-See.",
        stat_alt: "Höhe",
        stat_pop: "Einwohner",
        gemello_title: "Digitaler Zwilling",
        gemello_sub: "Entdecken Sie Tadasuni in 3D mit unserer interaktiven virtuellen Tour",
        gemello_cta: "Jetzt entdecken",
        attrazioni_title: "Sehenswürdigkeiten",
        eventi_title: "Veranstaltungen & News",
        eventi_read_more: "Mehr lesen",
        contact_title: "Kontaktieren Sie uns",
        contact_name: "Name",
        contact_email: "E-Mail",
        contact_phone: "Telefon",
        contact_message: "Nachricht",
        contact_consent: "Ich akzeptiere die Verarbeitung meiner personenbezogenen Daten",
        contact_send: "Senden",
        contact_success: "Nachricht gesendet! Vielen Dank für Ihre Nachricht.",
        contact_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        chat_title: "Tadasuni Assistent",
        chat_placeholder: "Stellen Sie eine Frage zum Dorf…",
        chat_welcome: "Hallo! Ich bin der Tadasuni-Assistent. Was möchten Sie über das Dorf erfahren?",
        chat_send: "Senden",
        eventi_page_title: "Veranstaltungen & News",
        eventi_page_sub: "Entdecken Sie die Veranstaltungen und Neuigkeiten aus dem Dorf Tadasuni",
        back_home: "Zurück zur Startseite",
        attr_page_title: "Tadasuni entdecken",
        attr_page_sub: "Sehenswürdigkeiten, Restaurants, Unterkünfte und Routen",
        tab_all: "Alle",
        tab_attractions: "Sehenswürdigkeiten",
        tab_food: "Wo essen",
        tab_stay: "Wo übernachten",
        tab_itin: "Routen",
        map_link: "Auf Karte anzeigen",
        footer_tag: "Dorf-Erlebnis — Zentrale Sardinien, Barigadu",
    },
};
